import React from "react";
import styled from "@emotion/styled";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";

export const UnablePage = () => {
  return (
    <Container>
      <ReportGmailerrorredIcon className="icon" color="secondary" />
      <p>Esta página no está disponible</p>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;

  .icon {
    font-size: 75px;
    opacity: 0.5;
  }

  p {
    color: grey;
  }
`;
